import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetExportRequest = {
	exportId: number;
};

export const getExport = createGetEndpoint<GetExportRequest, Blob>(
	(request) => `/api/v3/core/exports/${request.exportId}/download`,
	{ responseIsBlob: true }
);
